import { Component, OnInit } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { ActivatedRoute } from '@angular/router';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { DevicePeripheral } from 'src/app/models/device-models/device-peripheral-model/device-peripheral.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-device-peripheral-dashboard',
  templateUrl: './device-peripheral-dashboard.component.html',
  styleUrls: ['./device-peripheral-dashboard.component.scss']
})
export class DevicePeripheralDashboardComponent implements OnInit {

  deviceInternalId;
  peripheralInfo: DevicePeripheral;
  peripheralTypes;
  peripheralConnectionTypes;
  getPeripheralSubscription: Subscription;
  getPeripheralTypesSubscription: Subscription;

  constructor(private devicesDevicesService: DevicesDevicesService,
    private userStorageService: UserStorageService,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackBarService,
    private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.deviceInternalId = this.activatedRoute.snapshot.params['deviceid'];
    this.setBreadcrumb();
    this.getPeripheral();
    this.getPeripheralTypes();
  }

  public getPeripheral() {
    const internalId = this.activatedRoute.snapshot.params['peripheralid'];
    this.getPeripheralSubscription = this.devicesDevicesService.getPeripheral(internalId).pipe(
      tap(o => this.peripheralInfo = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getPeripheralTypes() {
    this.getPeripheralTypesSubscription = this.devicesDevicesService.listOfPeripheralTypes().pipe(
      tap(o => this.peripheralTypes = o.peripheralTypes),
      tap(o => this.peripheralConnectionTypes = o.peripheralConnectionTypes),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-ethernet', 'devices-page.peripheral detail', '/device/' + this.deviceInternalId, [new BRoute('devices-page.devices', '/devices'), new BRoute('devices-page.device detail', '/device/' + this.deviceInternalId), new BRoute('devices-page.peripheral detail')]));
  }
}
